import type { VpIconName } from '@vtmn-play/react'
import { VpIcon } from '@vtmn-play/react'

interface SectionHeaderProps {
  title: string
  iconName?: VpIconName
}

export function SectionHeader({ title, iconName = 'function-tiles' }: Readonly<SectionHeaderProps>) {
  return (
    <div className="quick-search__section-header">
      <div className="quick-search__section-header-main">
        <span className="quick-search__section-header-icon">
          <VpIcon name={iconName} />
        </span>
        <h3>{title}</h3>
      </div>
    </div>
  )
}
